module.exports = __webpack_public_path__ + "static/media/9-closet-08_14_2020.48838278.jpg";